import { useEffect, useState } from "react";
import { useStoreUpdaterWithAPI } from "../../../../../../Hooks/UseStoreUpdaterWithApi";
import { useSelector } from "react-redux";
import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  notification,
  Radio,
  Row,
  Select,
} from "antd";
import { APIConstants } from "../../../../../../Common/APIConstants";

export const MeterDrawer = ({
  onClose,
  isAdd,
  selectedRow,
  isUpdate,
  refetch,
  setRefetch,
  form,
}) => {
  const { makeRequest } = useStoreUpdaterWithAPI();
  const [addFormdata, setAddFormData] = useState([]);
  const modeselect = useSelector((state) => state.darkMode);
  const { isdarkMode } = modeselect;
  const [modules, setModules] = useState([]);
  const [selectedSiteID, setSelectedSiteID] = useState(null);
  const [optionconverter, setOptionConverter] = useState([]);
  const [selectedSiteName, setSelectedSiteName] = useState([]);
  const [meterdetail, setMeterdetails] = useState([]);
  const [meterlocation, setMeterLocation] = useState([]);
  const [meterSuppliers, setMeterSupplier] = useState([]);
  const [supplier, setSupplier] = useState([]);

  const handleClear = () => {
    form.resetFields();
  };

  const handleNotification = (msg, status) => {
    notification.open({
      message: msg,
      type: status,
      placement: "topRight",
      duration: 3,
    });
  };

  useEffect(() => {
    if (isUpdate && selectedRow) {
      form.setFieldsValue(selectedRow);
      setSelectedSiteName(selectedRow.sitename || "");
    } else {
      form.resetFields();
    }
  }, [isAdd, isUpdate, selectedRow, form]);
  console.log(selectedRow);

  useEffect(() => {
    if (isUpdate && selectedRow) {
      setSelectedSiteID(selectedRow.sitE_ID);

      form.setFieldsValue({
        meterid: selectedRow.meterid,
        metername: selectedRow.metername,
        metermodel: selectedRow.metermodel,
        portNo: selectedRow.portNo,
        sitename: selectedRow.sitename,
        active: selectedRow.active,
        startingAddress: selectedRow.startingaddress,
        NoOfRegisters: selectedRow.numberOfRegisters,
        baudRate: selectedRow.baudRate,
        meterSupplier: selectedRow.meterSupplier,
        moduleID: selectedRow.moduleID,
        meterlocation: selectedRow.meterlocation,
        ipAddress: selectedRow.ipAddress,
        Description: selectedRow.description,
        Department: selectedRow.department,
      });
    }
  }, [isUpdate, selectedRow, form]);

  const handleAddFormChange = (changedValues, allValues) => {
    console.log(allValues);
    setAddFormData(allValues);
  };

  const fetchData = () => {
    if (selectedSiteID) {
      getModules();
      getConverter();
      meterdetails(selectedSiteID);
      meterLocation(selectedSiteID);
      meterSupplier(selectedSiteID);
    }
  };

  useEffect(() => {
    fetchData();
  }, [selectedSiteID]);

  const handleFormSubmit = async () => {
    try {
      const formData = form.getFieldsValue();
      console.log(formData.sitename);
      console.log(selectedSiteID);
      console.log(formData);

      // if (!formData.startingAddress) {
      //   formData.startingAddress = formData.ipAddress;
      // }

      const portNo = Number(formData.portNo) || 0;
      const apiData = {
        departmentId: selectedSiteID || 0,
        siteId: selectedSiteID || 0,
        meterMeterId: String(formData.meteR_METERID || ""),
        meterName: formData.metername || "",
        meterModelName: formData.metermodel || "",
        department: formData.Department || "",
        siteName: formData.sitename || "",
        description: formData.Description || "",
        meterLocation: String(formData.meterlocation) || "",
        enabled: formData.active,
        startingAddress: formData.startingaddress || "",
        numberOfRegisters: formData.numberofregisters || "",
        baudRate: formData.baudRate || "",
        meterSupplier: String(formData.meterSupplier) || "",
        portNo: portNo || 0,
        ipAddress: formData.ipAddress || "",
        module: formData.module || 0,
        isReport: true,
      };

      const url = isUpdate
        ? APIConstants.UPDATE_CONFIG_METER
        : APIConstants.CONFIG_INSERT_METER;
      const method = isUpdate ? "POST" : "POST";

      const response = await makeRequest({
        type: method,
        url: url,
        body: apiData,
      }); 

      console.log(response.message);

      handleNotification(
        isUpdate
          ? "Successfully Updated"
          : response.message || "Successfully Added",
        "success"
      );
      // isUpdate? setRefetch(!refetch):''
      form.resetFields();
      setRefetch(!refetch); // Toggle refetch to refresh the data
      onClose();
    } catch (err) {
      console.error("Failed to add or update meter:", err);
      handleNotification(
        `Failed to ${isUpdate ? "update" : "add"}. Error: ${err.message || "Unknown error"}`
      );
    }
  };

  const handleLanConverterChange = (value, option) => {
    console.log(value)
    setSelectedSiteID(value);
    setSelectedSiteName(option.children);
    form.setFieldsValue({ sitename: option.children });
    console.log(value);
    console.log(option.children);
  };

  const getModules = () => {
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_MODULES}`,
    }).then((res) => {
      if (res && res.length > 0) {
        setModules(res);
      }
      console.log("Get Modules :", res);
    });
  };

  useEffect(() => {
    getModules();
  }, []);

  const getConverter = () => {
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_CONFIG_CONVERTER}`,
    }).then((res) => {
      console.log("Converter:", res);
      if (res && res.length > 0) {
        setOptionConverter(res);
      }
    });
  };

  useEffect(() => {
    if (optionconverter.length === 0) {
      getConverter();
    }
  }, [optionconverter]);

  const meterdetails = (siteID) => {
    // if (!siteID) return;
    console.log(siteID)

    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_METER_MODAL_DETAILS}?SupplierID=${siteID}`,
    }).then((res) => {
      console.log(res)
      if (res && res.length > 0) {
        setMeterdetails(
          res.map((item) => ({
            modelId: item.modelID,
            modelName: item.modelName,
          }))
        );
      }
    });
  };

  useEffect(() => {
    meterdetails(supplier);
    console.log(supplier)
  }, [supplier]);

  const meterLocation = (siteID) => {
    if (!siteID) return;
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_METER_LOCATION}?ConverterID=${siteID}`,
    }).then((res) => {
      setMeterLocation(
        res.map((item) => ({
          locationId: item.meterlocationid,
          locationName: item.meterlocationname,
        }))
      );
    });
  };

  useEffect(() => {
    meterLocation(selectedSiteID);
  }, [selectedSiteID]);

  const meterSupplier = () => {
    makeRequest({
      type: APIConstants.GET,
      url: `${APIConstants.GET_DEVICES_DETAILS}`,
    }).then((res) => {
      console.log("Meter supplier :", res);
      if(res&&res.length){
        // const uniqueMeterSuppliers = Array.from(
        //   new Set(res.map((item) => item.meterSupplier))
        // ).map((supplier) => ({
        //   meterSupplier: supplier,
        // }));
        // console.log(uniqueMeterSuppliers);
        setMeterSupplier(res);
      }
    });
  };

  useEffect(() => {
    meterSupplier();
  }, []);

  const handleSupplierChange=(value)=>{
    console.log(value)
    setSupplier(value)
  }

  return (
    <Form
      form={form}
      onFinish={handleFormSubmit}
      name="add-group-form"
      className="font-bold "
      layout="vertical"
      onValuesChange={handleAddFormChange}
      initialValues={isAdd ? {} : selectedRow}
    >
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            // label="Device ID"
            label={<span className={isdarkMode ? "text-white" : "text-black"}>Device ID</span>}
            name="meteR_METERID"
            rules={[{ required: true, message: "Please select device ID" }]}
          >
            <InputNumber placeholder="Enter device id"
              disabled={isUpdate ? true : false}
               style={{
                  width: "100%",
                }}
              className={isdarkMode ? "dark-input-number" : "light-input-number"}

            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            // label="Device Name"
            label={<span className={isdarkMode ? "text-white" : "text-black"}>Device Name</span>}
            name="metername"
            rules={[{ required: true, message: "Please select device name" }]}
          >
            <Input   
            placeholder="Enter device name"
            className={isdarkMode ? "dark-input-number" : "light-input-number"}
/>
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
       
     
        <Col span={12}>
          <Form.Item
            // label="Converter"
            label={<span className={isdarkMode ? "text-white" : "text-black"}>Converter</span>}
            name="sitename"
            rules={[
              { required: true, message: "Please select LanConverter name" },
            ]}
          >
            <Select
              className={`${isdarkMode ? "custom-select-dark select-dropdown-background" : "custom-select-light"}`}
              dropdownClassName={
                isdarkMode
                  ? "select-dropdown-background select-dropdown-background-group"
                  : "light-mode-dropdown"
              }
              placeholder="Selcted Converter"
              onChange={handleLanConverterChange}
              value={selectedSiteID}
              disabled={isUpdate ? true : false}
            >
              {optionconverter.map((item) => (
                <Option key={item.siteID} value={item.siteID}>
                  {item.siteName}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
         <Col span={12}>
           <Form.Item
            // label="Modules"
            label={<span className={isdarkMode ? "text-white" : "text-black"}>Modules</span>}
            name="module"
            rules={[{ required: true, message: "Please select Module" }]}
          >
            <Select
              className={`${isdarkMode ? "custom-select-dark select-dropdown-background" : "custom-select-light"}`}
              dropdownClassName={
                isdarkMode
                  ? "select-dropdown-background select-dropdown-background-group"
                  : "light-mode-dropdown"
              }
              placeholder="Select a module"
            >
              {modules.map((item) => (
                <Select.Option key={item.moduleId} value={item.moduleId}>
                  {item.moduleName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
         <Col span={12}>
          <Form.Item
            // label="Device Supplier"
            label={<span className={isdarkMode ? "text-white" : "text-black"}>Device Supplier</span>}
            name="meterSupplier"
            rules={[
              { required: true, message: "Please select device supplier" },
            ]}
          >
            <Select
              className={`${isdarkMode ? "custom-select-dark select-dropdown-background" : "custom-select-light"}`}
              dropdownClassName={
                isdarkMode
                  ? "select-dropdown-background select-dropdown-background-group"
                  : "light-mode-dropdown"
              }
              placeholder="Select a device supplier"
              onChange={handleSupplierChange}
              value={supplier}
            >
              {meterSuppliers.map((item) => (
                <Option key={item.supplierID} value={item.supplierID}>
                  {item.supplierName}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            // label="Device Model"
            label={<span className={isdarkMode ? "text-white" : "text-black"}>Device Model</span>}
            name="metermodel"
            rules={[{ required: true, message: "Please select device model" }]}
          >
            <Select
               className={`${isdarkMode ? "custom-select-dark select-dropdown-background" : "custom-select-light"}`}
              dropdownClassName={
                isdarkMode
                  ? "select-dropdown-background select-dropdown-background-group"
                  : "light-mode-dropdown"
              }
              placeholder="Select Device model"
              onChange={(value, option) =>
                form.setFieldsValue({ metermodel: option.children })
              }
            >
              {meterdetail.map((item) => (
                <Option key={item.modelId} value={item.modelId}>
                  {item.modelName}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
       
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            // label="IP Address"
            label={<span className={isdarkMode ? "text-white" : "text-black"}>IP Address</span>}
            name="ipAddress"
            rules={[{ required: true, message: "Please select category name" }]}
          >
            <Input  
            placeholder="Enter an IP address"
            className={isdarkMode ? "dark-input-number" : "light-input-number"}
/>
          </Form.Item>
        </Col>
          <Col span={12}>
          <Form.Item
            // label="Port No"
            label={<span className={isdarkMode ? "text-white" : "text-black"}>Port No</span>}
            name="portNo"
            rules={[{ required: true, message: "Please select port number" }]}
          >
            <Input type="number"  placeholder="Enter port number"
              className={isdarkMode ? "dark-input-number" : "light-input-number"}
 />
          </Form.Item>
        </Col>
      </Row>

      {/* <Row gutter={16}>
        <Col span={12}>
          <Form.Item
          label={<span className={isdarkMode ? "text-white" : "text-black"}>No of Registers</span>}
            // label="No Of Registers"
            name="numberofregisters"
            rules={[
              { required: true, message: "Please select number of registers" },
            ]}
          >
            <Input     className={isdarkMode ? "dark-input-number" : "light-input-number"}
            placeholder="Enter no of registers"
/>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            // label="Baud rate"
            label={<span className={isdarkMode ? "text-white" : "text-black"}>Baud rate</span>}
            name="baudRate"
            rules={[{ required: true, message: "Please select baud rate" }]}
          >
            <Input  placeholder="Enter baud rate "
                className={isdarkMode ? "dark-input-number" : "light-input-number"}
/>
          </Form.Item>
        </Col>
      </Row> */}
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            // label="Device Location"
            label={<span className={isdarkMode ? "text-white" : "text-black"}>Device Location</span>}
            name="meterlocation"
            rules={[
              { required: true, message: "Please select device location" },
            ]}
          >
            {/* <Select
               className={`${isdarkMode ? "custom-select-dark select-dropdown-background" : "custom-select-light"}`}
              dropdownClassName={
                isdarkMode
                  ? "select-dropdown-background select-dropdown-background-group"
                  : "light-mode-dropdown"
              }
              onChange={(value, option) =>
                form.setFieldsValue({ meterlocation: option.children })
              }
              placeholder="Select device location"
            >
              {meterlocation.map((item) => (
                <Option key={item.locationId} value={item.locationId}>
                  {item.locationName}
                </Option>
              ))}
            </Select> */}
              <Input placeholder="Enter device location"
              disabled={isUpdate ? true : false}
               style={{
                  width: "100%",
                }}
              className={isdarkMode ? "dark-input-number" : "light-input-number"}

            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            // label="Active"
            label={<span className={isdarkMode ? "text-white" : "text-black"}>Active</span>}
            name={"active"}
            rules={[{ required: true, message: "Please select an option" }]}
          >
            <Radio.Group>
              <Radio value={true} className={isdarkMode ? "text-white" : "text-black"}>Yes</Radio>
              <Radio value={false} className={isdarkMode ? "text-white" : "text-black"} >No</Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
      </Row>
      {/* 
      <Form.Item className="flex justify-end">
        <Button htmlType="submit" className=" mr-2">
          Save
        </Button>
        <Button className="" type="primary" onClick={handleClear}>
          Clear
        </Button>
      </Form.Item> */}
    </Form>
  );
};
